import React from "react";
import chicoLogo from "../assets/chicoLogo.jpg";
import whatsappLogo from "../assets/whatsapp.png";
import styles from "../styles/header.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone, faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
function Header() {
  return (
    <header className="spaceBetween">
      <div className="headerLeft">
        <Link to={"/"}>
          <img className="headerLogo" src={chicoLogo} alt="chicoLogo" />
        </Link>
      </div>
      <div className="headerRight">
        <div className="headerTopRight">
          <a href="mailto:chicocabinet@gmail.com">
            <FontAwesomeIcon className="faEnvelope" icon={faEnvelope} />
          </a>
          <a href="tel:+15305849474">
            <FontAwesomeIcon className="faPhone" icon={faPhone} />
            <span>530 584 9474</span>
          </a>
          <a href="https://api.whatsapp.com/send?phone=15305849474">
            <img className="whatsappLogo" src={whatsappLogo} alt="" />
          </a>
        </div>

        <nav>
          <ul>
            <li>
              <a href="#aboutContainer"> About</a>
            </li>
            <li>
              <a href="#cabinetContainer"> Cabinets</a>
            </li>
            <li>
              <a href="#processContainer"> Process</a>
            </li>
            <li>
              <a href="#formContainer"> Contact Us</a>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
}

export default Header;
